<template>
  <div class="side-frame-success">
    <span style="font-size: 14px; color: #606266">{{
      this.$l('INDEX.form_label_business_name') || '业务员'
    }}</span>
  </div>
</template>
<script>
// 初始表单

export default {
  props: {},
  data() {
    return {}
  },
  mounted() {
    this.query()
  },
  methods: {
    query() {
      this.$emit('query')
    },
  },
}
</script>
